/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
export const API_PATIENT_REGISTER = '/register';
export const API_PATIENT_SIGNIN = '/signin';
export const API_PATIENT_ACTIVATION = '/confirm-account';
export const API_GET_APPOINTMENT_SLOT = '/api/appointmentslot';
export const API_BOOK_APPOINTMENT = '/api/book-appointment';
export const API_PATIENT_CCDA_VIEW = '/api/ccdaview';
export const API_PROVIDER_SEARCH = '/api/public/search';
export const API_GET_PROVIDER_PROFILE = '/api/public/providerProfile';
export const API_GET_PRACTICE_PROFILE = '/api/public/practiceProfile';
export const API_FIND_FAV_PROVIDER = '/api/find-favorite-doctor';
export const API_ADD_FAV_PROVIDER = '/api/add-favorite-doctor';
export const API_LIST_APPOINTMENT = '/api/list-appointment';
export const API_CHANGE_PASSWORD = '/api/changePassword';
export const API_APPOINTMENT_PAYMENT = '/api/addPayment';/*Bug #611  @author Jithin Kuriakose on 23 Sept 2021*/
export const API_PATIENT_SIGNOUT = '/signout';
export const API_REFRESH_TOKEN = '/refreshToken';/*Bug#755  @author Aby Joseph on 09 Feb 2022*/
export const API_LIST_NOTIFICATION = '/api/listNotification'; /** Bug #770 Midhila Velayudhan  05 march 2022*/
/*** End ***/
/**
 * Bug #438
 * @Author Anupama P
 * @Date 22 June 2021
 */
/**
 * Bug #452 - modified for getUserDemographics,saveUserDemographics API url changes
 * @Author Aby Joseph
 * @Date 14 July 2021
 */
export const API_GET_USER_DEMOGRPHICS = '/api/getUserDemographics';
export const API_SAVE_USER_DEMOGRPHICS = '/api/saveUserDemographics';
/*** End ***/
/*
    CR #449
    @Author Jithin Kuriakose
    @Date 25 June 2021
*/
export const API_QR_CODE_GENERATE = '/api/public/qrcode/generate';
export const API_QR_CODE_VALIDATOR = '/qr/qrvalidator';
/*** End ***/
/**
* Bug #470 
* @Author Deepu Stanly
* @Date 5 July 2021 
 * */
export const API_SEND_RESET_PASSWORD_TOKEN = '/sendResetPasswordToken';
export const API_RESET_PASSWORD = '/resetPassword';
/** End Bug #470 **/
/** 
 * Bug#425
 * @Author: Linda Susan Raju 
 * @Date: 05 July 2021
 */
export const API_GET_ALL_PROVIDERS_BY_PRACTICE_ID = '/api/public/getAllProviders';
/**End Bug#425*/
/** 
 * Bug#494
 * @Author: Linda Susan Raju 
 * @Date: 12 July 2021
 */
export const API_GET_HEALTH_RECORD_VITALS = '/api/clinical/vitals';
export const API_GET_HEALTH_RECORD_MEDICATIONS = '/api/clinical/medications';
/**End Bug#494*/

/* Bug#493
* @Author: Liya Baby
* @Date: 12 July 2021
*/
export const API_GET_HEALTH_RECORD_ALLERGY = '/api/clinical/allergy';
export const API_GET_HEALTH_RECORD_OTHER_ALLERGY = '/api/clinical/allergy';
export const API_GET_HEALTH_RECORD_MEDICAL_CONDITION = '/api/clinical/problem';
export const API_GET_HEALTH_RECORD_MEDICAL_CONDITION_PAST = '/api/clinical/problem';
export const API_GET_HEALTH_RECORD_MEDICAL_CONDITION_FAMILY_HISTORY = '/api/clinical/problem';

/** 
 * Bug#496
 * @Author: Liya Baby
 * @Date: 13 July 2021
 */
export const API_GET_HEALTH_RECORD_PROCEDURES = '/api/clinical/procedures';
export const API_GET_HEALTH_RECORD_IMMUNIZATION = '/api/clinical/immunizations';

/**
 * Bug #500
 * @Author Anupama P
 * @Date 14 Jul 2021
 */
export const API_GET_HEALTH_RECORD_ASSESSMENT = '/api/clinical/assessment';
export const API_GET_HEALTH_RECORD_GOALS = '/api/clinical/goals';
export const API_GET_HEALTH_RECORD_HEALTH_CONCERNS = '/api/clinical/healthconcerns';
export const API_GET_HEALTH_RECORD_IMPLANTED_DEVICES = '/api/clinical/implanteddevices';
export const API_GET_HEALTH_RECORD_SMOKING_STATUS = '/api/clinical/smokingstatus';
export const API_GET_HEALTH_RECORD_RESULT = '/api/clinical/result';
export const API_GET_HEALTH_RECORD_LABS = '/api/clinical/labs';

/**
 * Bug #503
 * @Author Aby Joseph
 * @Date 19 July 2021
 */
export const API_INSURANCE_SEARCH = '/api/searchInsurance';
export const API_INSURANCE_SAVE = '/api/saveUserInsurance';
export const API_INSURANCE_DELETE = '/api/deleteUserInsurance';
export const API_GET_PATIENT_INSURANCE = 'api/getUserInsurance';
/*** End ***/

/**
* Bug #550
* @Author Shanjoph
* @Date 8 Aug 2021
*/
export const API_LIST_STATEMENT = '/api/listStatement';
export const API_GET_STATEMENT = '/api/getStatement';
/*** End ***/

export const API_GET_KIOSK_FORM = '/api/getKioskForm';/** Bug#507 @Author: Linda Susan Raju @Date: 21 Jul 2021 */

export const API_VIRTUAL_GET_PROFILE_STATUS = '/api/virtual/getProfileStatus';/** Bug#576 @Author: Linda Susan Raju @Date: 25 Aug 2021 */
/**
 * Bug #566
 * @Author Aby Joseph
 * @Date 25 August 2021
 */
export const API_QR_CODE_GENERATE_PROVIDER = '/api/virtual/qrcode?guid=';
export const API_LIST_APPOINTMENTS_VIRTUAL_CHECKIN = '/api/virtual/listappointment';
/*** End ***/
/**
 * Bug #604
 * @Author Liya Baby
 * @Date06 Sept 2021
 */
export const API_UPDATE_APPOINTMENT_STATUS = '/api/virtual/updateAppointment';
/*** End ***/
export const API_LIST_ACTIVE_FORM = '/api/listActiveForm';/** Bug#576 @Author: Linda Susan Raju @Date: 4 Sept */
/**export const API_GET_FORM_DATA = '/api/getFormData'; Bug#576 @Author: Linda Susan Raju @Date: 5 Sept 2021 */
export const API_GET_FORM_DATA = '/api/getPatientFormData';/** Bug#949 @Author:Midhila Velayudhan @Date: 14 jun 2022 replace the service getFormData to getPatientFormData */
export const API_SAVE_FORM_DATA = '/api/saveFormData';/** Bug#576 @Author: Linda Susan Raju @Date: 6 Sept 2021 */
export const API_GET_LIST_FORM = '/api/listForm'; /** Bug #655 @Author:Midhila Velayudhan @Date: 3 November 2021 */
export const API_UPDATE_LIST_FORM = '/api/updateFormStatus'; /** End #655 */
export const API_LIST_PATIENTFORMS = '/api/listPatientForms';/** Bug#606 @Author: Liya Baby @Date: 7 Sept 2021 */

export const API_GET_HEALTH_RECORD_COUNT = '/api/clinical/count';

export const API_SAVE_USER_PROFILE_IMAGE = '/api/saveUserProfileImage';/** Bug#623 @Author: Linda Susan Raju @Date: 05 Oct 2021*/
export const API_GET_DEPENDANT_MAP = 'api/getDependantMap';/** Bug#664 @Author: Aby Joseph @Date: 09 Dec 2021*/

export const API_UPLOAD_DOCUMENT = '/api/uploadDoc'; /** Bug#698 @Author: Linda Susan Raju @Date: 30 Dec 2021*/
export const API_GET_DOCUMENT = '/api/getDoc'; /** Bug#698 @Author: Linda Susan Raju @Date: 30 Dec 2021*/
export const API_GET_DOWNLOAD_DOCUMENT = '/api/downloadDoc'; /** Bug#698 @Author: Linda Susan Raju @Date: 6 Jan 2022*/
export const API_DELETE_DOCUMENT = '/api/deleteDoc'; /** Bug#698 @Author: Linda Susan Raju @Date: 10 Jan 2022*/
export const API_DELETE_PATIENT_FORMS = '/api/deletePatientForms'; /** Bug#698 @Author: Linda Susan Raju @Date: 10 Jan 2022*/
export const API_GET_SAVED_CARDS = '/api/getSavedCards';/*Bug #732  @author Aby Joseph on 18 Jan 2022*/
export const API_GET_PROVIDER_LISTAPPOINTMENTS = '/api/provider/listAppointments' /** Bug #744 Midhila velayudhan @Date:15/02/2022 */
export const API_GET_ALL_PATIENTS = '/api/getMyPatients';
export const SAVE_FCM_TOKEN = '/api/savePushToken';


export const API_VERIFY_OTP = '/api/verifyotp'; /** Bug#709 @Author: Liya Baby @Date: 27 Jan 2022*/
export const API_RESEND_OTP = '/api/resendCCPayOTP'; /** Bug#709 @Author: Liya Baby @Date: 27 Jan 2022*/
export const API_SCHEDULE_BROADCAST = '/api/scheduleJob'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const API_EDIT_SCHEDULED_BROADCAST = '/api/editBroadcastJob'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const API_RESCHEDULED_BROADCAST = '/api/rescheduleJob'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const API_LIST_MYPATIENTS = '/api/provider/listPatients';/**Bug #745 Midhila Velayudhan @Date:18/02/2022 */
export const API_GET_BROADCAST = 'api/listBroadcastJob'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_DELETE_BROADCAST = 'api/deleteJob'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_GET_BROADCAST_TEMPLATE = 'api/selectTemplate'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_GET_BROADCAST_TEMPLATE_DETAILS = 'api/getTemplateDetails'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_GET_BROADCAST_PATIENT_GROUPS = 'api/selectPatientGroup'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_GET_BROADCAST_PATIENTs = 'api/searchUsers'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Anupama @Date 04Mar2022 */
export const API_SAVE_PATIENT_GROUP = '/api/savePatientGroup'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const API_GET_PATIENT_GROUP_MEMBERS = '/api/getPatientGroupMembers'; /** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */

export const API_PUBLIC_VERIFY_OTP = 'api/public/verifyRegOTP' /** Bug #802 Midhila Velayudhan Date : 22 march 2022 */
export const API_SEND_REG_OTP = 'api/public/sendRegOTP' /** Bug #802 Midhila Velayudhan Date : 24 march 2022 */
export const API_CHECK_APPT_USER_EXIST = 'api/public/apptReminderUserCheck'; /** Bug #808 - Appointment reminder @Author: Aby @Date 22 Mar 2022 */
export const API_APPOINTMENT_REMINDER = 'api/scheduleApptReminder'; /** Bug #782 appointmnet reminder midhila  date: 22 march 2022 */
export const API_LIST_APPOINTMENT_REMINDER = 'api/listApptReminderJob';/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const API_REGISTER_USER_FROM_APPT = 'regUserFromAppt';/** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
export const API_DELETE_APPOINTMENT_REMINDER = 'api/deleteApptReminderJob';/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const API_GET_PROVIDER = '/api/getProvider'; /*Bug #819-Appointment reschedule implementation  @Author: Aby Joseph  @Date: 07 Apr 2022*/
export const API_PATIENT_GROUP_LIST = '/api/listPatientGroup' /** Bug #841 Midhila Velayudhan Date : april 26 2022 */
export const API_CREATE_PATIENT_GROUP = '/api/savePatientGroup';
/** Bug #841 Midhila Velayudhan Date : april 29 2022 */
export const API_PATIENT_GROUP_DELETE = '/api/deletePatientGroup'
export const API_PATIENT_GROUP_MEMBERS = '/api/getPatientGroupMembers'
/**End  */

/** Bug #838 Midhila Velayudhan Date : 19 april 2022 */
export const API_TEMPLATE_SAVE = '/api/saveTemplate';
export const API_LIST_TEMPLATE = '/api/listTemplate';
export const API_DELETE_TEMPLATE = '/api/deleteTemplate';
/** Date :21 april 2022 */
export const API_GET_DEFAUTL_TEMPLATE = '/api/getDefualtTemplate';
/** End  */

export const API_UPDATE_FORM = '/api/updateform';/** Bug #859@Author Liya Baby @Date : 05 May 2022 */
export const API_SELECT_PROVIDERS = '/api/selectProviders';/** Bug #859 @Author Liya Baby @Date : 09 May 2022 */
export const API_SELECT_APPTTYPES = '/api/selectPortalApptTypes';/** Bug #859 @Author Liya Baby @Date : 09 May 2022 */
export const API_FORM_CONFIG_DETAILS = '/api/getFormConfigDetails';/** Bug #859 @Author Liya Baby @Date : 09 May 2022 */
export const API_SAVE_CONFIG_DETAILS = '/api/saveFormConfigDetails';/** Bug #859 @Author Liya Baby @Date : 09 May 2022 */






export const API_GET_TEMPLATE_BY_CATEGORY = '/api/getTemplateByCategory';// date 26 april 2022 Bug #838

export const API_PAUSE_APPT_REMAINDER = '/api/pauseApptReminderJob';/*Bug #879 - Facility - Implement an option to turned off/on appointment recall, reminder, email confirmation @Author Jithin Kuriakose @Date 11 May 2022*/
export const API_PAUSE_APPT_EMAIL_CONFIRMATION = '/api/pauseTemplate';/*Bug #879 - Facility - Implement an option to turned off/on appointment recall, reminder, email confirmation @Author Jithin Kuriakose @Date 11 May 2022*/
export const API_DELETE_SAVED_CARD = 'api/deleteSavedCards';/**Bug #881 - Implement delete saved card functionality @Author Jithin Kuriakose @date 12May2022 */
export const API_GET_APPOINTMENTS_SEARCH = 'api/getPsAppointment';/**Bug #878 - Implement  appointments search @Author Liya Baby @date 30 May2022 */
export const API_GET_PATIENT_SEARCH = 'api/getPsPatient'; /** Bug #939 Midhila Velayudhan Date : 16/06/2022 */

export const API_RECALL_REMINDER = 'api/saveRecallJob';
export const API_PAUSE_RECALL_REMAINDER = '/api/pauseRecallJob';/*Bug #879 - Facility - Implement an option to turned off/on appointment recall, reminder, email confirmation @Author Jithin Kuriakose @Date 11 May 2022*/
export const API_GET_RECALL_TYPE = '/api/getRecallType';
export const API_LIST_RECALL_REMINDER = 'api/listRecallJob';/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const API_DELETE_RECALL_REMINDER = 'api/deleteRecallJob';/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const API_GET_PS_PATIENT_GROUP_MEMBERS = '/api/getPsPatientGroupMembers';  /** Bug #841 - Implement Patient Groups in facility @Author: Jithin Kuriakose @Date 17Jun2022 */
export const API_FIND_FORM_DATA = '/api/findFormData';  /** Bug #1004 - @Author: Aby Joseph @Date 05Aug2022 */


export const API_INBOX_OUTBOX_MESSAGE_LIST = '/api/patcomm/list'; /*** Message Api -inbox and sent items  @author shaheel navas @date 30Aug2022 */
export const API_MESSAGE_GET_FORM = '/api/getPatientForm'; /**Message GET FORM @author Shaheelnavas @date 04 sept-2022 */
export const API_SEND_REPLY_MESSAGE = "api/patcomm/composeAndReply"
export const API_INBOX_OUTBOX_SEARCH = 'api/patcomm/searchMessage'; /** Date 29/09/2022 Midhila velayudhan */
export const API_MESSAGE_MARK_AS_READ_UNREAD = 'api/patcomm/markAsReadUnread'; /** Date 30/09/2022 Midhila Velayudhan Bug #1009 To mark read/unread messages */
export const API_DELETE_MESSAGE = "api/patcomm/deleteMessage"/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
export const API_STAR_MESSAGE = "api/patcomm/markAsStarred"/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
export const API_SEARCH_PROVIDER = "api/fetchProvider"; /** Bug #1008 @Author:shaheel navas @Date 26oct2022*/
export const API_SSO_LOGIN = "sso/message/"//Bug #1072 @Author Anupama @date 12Oct2022
export const API_PATIENT_FORMS = 'api/list/filled/patientForms'/** Bug #1011 Midhila Velayudhan Date:19/10/2022 */
export const API_FORMS_LOCK ='api/patient/form/isLocked'/** Bug #1118 Midhila velayudhan 13/11/2022 */
export const API_FORMS_WITH_PATIENTFORMID='api/patient/findPatientForm'/** Bug #1153 date :18/11/2022 patientfilled form based on patientFormId */
export const API_PATIENTGROUP_MESSAGE_MEMBERS ='api/getGroupMsgMembers'/** Bug#1116 Midhila velayudhan 30/11/2022 */
export const API_CONFIG_APPOINTMENT_LIST = 'api/listApptScheduleConfig' /**@Bug #1012 @author Shaheelnavas @Date:09/11/2022 */
export const API_GET_PARENT_PROVIDER_LOCATIONS = '/api/listLocation'; /** Bug #1012 - @Author: Omar Fayadh @Date 07Nov2022 */
export const API_POST_APPT_SCHEDULE_CONFIG = 'api/saveApptScheduleConfig'; /** Bug #1012 - @Author: Omar Fayadh @Date 07Nov2022 */
